export default __webpack_public_path__ + "images/6aa3dd948d10c5793457ef4b49040a6a-tampa_mobile.webp";